import { useMemo } from 'react';
import { useAppSelector } from '@/app/hooks';
import { selectPublicSettings } from '@/features/publicSettings/publicSettingsSlice';

export const useFeatureFlags = () => {
  const { authUserSettings } = useAppSelector(selectPublicSettings);
  const transferRule = authUserSettings?.transferRule;

  const featureFlags = useMemo(() => {
    const isFeatureEnabled = (item: any) => item === undefined || item === 'false';
    const isOptInFeatureEnabled = (item: any) => item === 'false';

    return {
      isSwiftFeature: transferRule?.swift?.enabled ?? isFeatureEnabled(process.env.REACT_APP_FEATURE_SWIFT_DISABLE),
      isNraFeature: transferRule?.tax?.enabled ?? isFeatureEnabled(process.env.REACT_APP_FEATURE_NRA_DISABLE),
      isInterTransferFeature:
        transferRule?.transfer?.interBankTransferEnabled ?? isFeatureEnabled(process.env.REACT_APP_FEATURE_INTER_TRANSFER_DISABLE),
      isStandingOrderFeature: transferRule?.standingOrder?.enabled ?? true,
      isDeferTransferFeature: transferRule?.transfer?.deferTransferEnabled ?? true,
      isCrossCurrencyTransferFeature: transferRule?.transfer?.enableCrossCurrencyTransfer ?? false,
      isCrossCurrencyPaymentFeature: transferRule?.payment?.enableCrossCurrencyPayment ?? false,
      deferredTransferConfig: transferRule?.transfer?.deferredTransfer,
      swiftConfig: transferRule?.swift,
      isDepositsFeature: authUserSettings?.depositRule?.enabled ?? isFeatureEnabled(process.env.REACT_APP_FEATURE_DEPOSITS_DISABLE),
      isLoansFeature: authUserSettings?.loanRule?.enabled ?? isFeatureEnabled(process.env.REACT_APP_FEATURE_LOANS_DISABLE),
      // Flags pilotés uniquement par variables d'environnement
      isBannerFeature: isFeatureEnabled(process.env.REACT_APP_FEATURE_BANNER_DISABLE),
      isCardFeature: isFeatureEnabled(process.env.REACT_APP_FEATURE_CARD_DISABLE),
      isExchangesFeature: isFeatureEnabled(process.env.REACT_APP_FEATURE_EXCHANGES_DISABLE),
      isSavingFeature: isFeatureEnabled(process.env.REACT_APP_FEATURE_SAVING_DISABLE),
      isStatementsFeature: isOptInFeatureEnabled(process.env.REACT_APP_FEATURE_STATEMENTS_DISABLE),
      isCheckbookFeature: authUserSettings?.checkbookRequestRule?.enabled !== false,
    };
  }, [transferRule, authUserSettings]);

  return featureFlags;
};
